import { AlertMessageInterface } from '../../models/alert-message.interface';

export interface AlertMessageInterfaceState {
  alert: AlertMessageInterface;
}

export const initialAlertMessageState: AlertMessageInterfaceState = {
  alert: null
};
